/* eslint max-lines: 0 */
import { getCorrelationId } from 'services/transportationRequestService';
import mrmFetch from 'util/fetchUtil';
import {
    tripRequestFormResponseFile,
    setTripRequestFormLoading,
    setSearchTerm,
    setDefaultStudentId,
    updateModel,
    setErrorMessage,
    setEnabledSubmit,
    setEnabledStudentDate,
    setSchoolDays,
    setTransportationNeeds,
    setShowDifferentAddress,
    setSchedule,
    setSubmitConfirmModalStatus,
    setSubmitFormMessage,
    setPopulationTypes,
    setKeyDropZone,
    setIsSameAddressCheck,
    setIsSameTripInfoCheck,
    setIsSameContactCheck,
    setIsSameSchoolCheck,
    setSelectedHomeAddress,
    setSelectedHomeAddress2,
    setSelectedPickUpAddress,
    setSelectedPickUpAddress2,
    setSelectedDropOffAddress,
    setSelectedDropOffAddress2,
    setSelectedSchoolAddress,
    setSelectedSchoolAddress2,
    setSelectedSchool,
    setSelectedStudent,
    setEmailErrors,
    setEnabledSchoolInput,
    setSelectedAccountHasNoEmail,
    setStudentStartDateErrorMessage,
    setStudentEndDateErrorMessage,
    setStudentBirthDateErrorMessage,
    setEnabledDraft,
    setIsDraftForSave,
    setUploadedDraftAttachments,
    cleanForm,
    updateOldDraftModel,
    setOldDraftPopulationTypes,
    setIsDraftSelected,
    setNonSchoolAddressList,
    setSelectedPreviousHomeAddress,
    setSelectedPreviousDropOffAddress,
    setSelectedPreviousPickUpAddress,
    setOldDraftTransportationNeeds,
    setCalledGetCorrelationId
} from 'redux/actions/tripRequestFormActions';
import { Enum } from 'util/EnumHelper';
import { localize } from 'util/Localizer';
import {
    personalInformationModel,
    formatPlaceHolderPhoneNumber,
    generalTripInformationModel,
    requestTypeDto,
    schoolInformationModel,
    emergencyContactInformationModel,
    transportationEquipmentDto,
    populationTypeDto,
    schoolDaysDto,
    scheduleModel
} from 'data/models/tripRequestForm/TripRequestFormModel';
import {
    dateFormatDateOfBirth,
    timeFormat
} from 'util/dateUtils';
import { validationPhoneNumber } from 'util/validationUtil';
import Auth from 'auth/Auth';
import { initialValues } from 'util/data/dataDecorator';
import { validateEmail } from 'util/textFormatters';
import {
    closeStyledSnackBar,
    openStyledSnackBar,
    setSnackbar
} from './styledSnackbarWrapperWorker';
import { searchStudent } from './districtTripTracker/dttStudentWorker';
// eslint-disable-next-line import/no-cycle
import { onDeleteTab } from './tripRequestFormSiblingHeaderWorker';
// eslint-disable-next-line import/no-cycle
import { formatTransporationNeeds, formatPopulationTypeGeneralTripInfo } from './tripRequestFormTripInformationWorker';
import isValidForm from './tripRequestForm/tripRequestFormValidation';

const errorLabel = 'tripRequestForm.messageError';

const isValidTime = (flagDay, pickUpDate, arrivalDate) => (!flagDay || (flagDay &&
    ((pickUpDate && !(Number.isNaN(pickUpDate.getTime()))) ||
        !pickUpDate) && ((arrivalDate && !(Number.isNaN(arrivalDate.getTime()))) ||
            !arrivalDate) && (pickUpDate || arrivalDate)));

const parentAppAccess = (value, name) => (dispatch) => {
    if(!validateEmail(value)) {
        dispatch(updateModel({
            [name] : true
        }));
    } else {
        dispatch(updateModel({
            [name] : false
        }));
    }
};

export const isDraftCorrect = (isUpdate) => (dispatch, getState) => {
    const { tripModel } = getState().TripRequestFormReducers;
    let isEnabledDraft = false;

    isEnabledDraft = tripModel.studentId !== '' && tripModel.studentFirstName !== '' &&
        tripModel.studentLastName !== '';

    dispatch(setEnabledDraft(isEnabledDraft));

    if (isUpdate) {
        dispatch(setIsDraftForSave(isEnabledDraft));
    } else {
        dispatch(setIsDraftForSave(false));
    }
};

const hasRequiredAddressFields = (tripModel, key) => (
    tripModel[`${key}AddressLine1`] && tripModel[`${key}AddressCity`] &&
    tripModel[`${key}AddressZipCode`] && tripModel[`${key}AddressState`]
);

const validateAddresses = (tripModel) => {
    const results = [];

    if (tripModel.amPickupLocation === "Home Address" || tripModel.pmDropOffLocation === "Home Address") {
        results.push(hasRequiredAddressFields(tripModel, 'student'));
    }

    if (tripModel.amPickupLocation === "Different Address") {
        results.push(hasRequiredAddressFields(tripModel, 'pickupLocation'));
    }

    if (tripModel.pmDropOffLocation === "Different Address") {
        results.push(hasRequiredAddressFields(tripModel, 'dropOffLocation'));
    }

    return results.every(x => x);
};

export const isNewCorrect = () => (dispatch, getState) => {
    const { tripModel,
        scheduleValid,
        emailErrors,
        populationTypes,
        transportationEquipmentNeeds } = getState().TripRequestFormReducers;
    let isDisabled = true;

    const inputTimesAreValid =
        scheduleValid.schoolPickupMonday && scheduleValid.schoolArrivalMonday &&
        scheduleValid.schoolPickupTuesday && scheduleValid.schoolArrivalTuesday &&
        scheduleValid.schoolPickupWednesday && scheduleValid.schoolArrivalWednesday &&
        scheduleValid.schoolPickupThursday && scheduleValid.schoolArrivalThursday &&
        scheduleValid.schoolPickupFriday && scheduleValid.schoolArrivalFriday &&
        scheduleValid.schoolPickupSaturday && scheduleValid.schoolArrivalSaturday &&
        scheduleValid.schoolPickupSunday && scheduleValid.schoolArrivalSunday;

    const isMondayValid = isValidTime(
        tripModel.schoolMonday,
        tripModel.schoolPickupMonday,
        tripModel.schoolArrivalMonday
    );

    const isTuesdayValid = isValidTime(
        tripModel.schoolTuesday,
        tripModel.schoolPickupTuesday,
        tripModel.schoolArrivalTuesday
    );

    const isWednesdayValid = isValidTime(
        tripModel.schoolWednesday,
        tripModel.schoolPickupWednesday,
        tripModel.schoolArrivalWednesday
    );

    const isThursdayValid = isValidTime(
        tripModel.schoolThursday,
        tripModel.schoolPickupThursday,
        tripModel.schoolArrivalThursday
    );

    const isFridayValid = isValidTime(
        tripModel.schoolFriday,
        tripModel.schoolPickupFriday,
        tripModel.schoolArrivalFriday
    );

    const isSaturdayValid = isValidTime(
        tripModel.schoolSaturday,
        tripModel.schoolPickupSaturday,
        tripModel.schoolArrivalSaturday
    );

    const isSundayValid = isValidTime(
        tripModel.schoolSunday,
        tripModel.schoolPickupSunday,
        tripModel.schoolArrivalSunday
    );

    const isValidAddresses = validateAddresses(tripModel);

    if (tripModel.requestType === requestTypeDto.update) {
        isDisabled = !(tripModel.studentId?.trim() &&
            tripModel.studentFirstName?.trim() &&
            tripModel.studentLastName?.trim() &&
            tripModel.studentDateOfBirth &&
            tripModel.parent1FirstName?.trim() &&
            tripModel.parent1Relationship?.trim() &&
            tripModel.parent1MobilePhone?.trim() &&
            isMondayValid && isTuesdayValid &&
            isWednesdayValid && isThursdayValid &&
            isFridayValid && isSaturdayValid && isSundayValid &&
            inputTimesAreValid);
    } else {
        isDisabled = !(tripModel.accountName?.trim() &&
            tripModel.studentId?.trim() &&
            tripModel.studentFirstName?.trim() &&
            tripModel.studentLastName?.trim() &&
            tripModel.studentDateOfBirth &&
            tripModel.tripStartDate &&
            tripModel.tripEndDate &&
            tripModel.parent1FirstName?.trim() &&
            tripModel.parent1Relationship?.trim() &&
            tripModel.parent1MobilePhone?.trim() &&
            tripModel.parent1MobilePhone !== formatPlaceHolderPhoneNumber &&
            tripModel.schoolName?.trim() &&
            tripModel.schoolAddressLine1?.trim() &&
            tripModel.schoolAddressCity?.trim() &&
            tripModel.schoolAddressZipCode?.trim() &&
            tripModel.schoolAddressState?.trim() &&
            tripModel.schoolPhone?.trim() &&
            tripModel.schoolPhone !== formatPlaceHolderPhoneNumber &&
            isValidAddresses &&
            isMondayValid && isTuesdayValid && isWednesdayValid && isThursdayValid && isFridayValid &&
            isSaturdayValid && isSundayValid && inputTimesAreValid &&
            (transportationEquipmentNeeds ?
                Object.values(transportationEquipmentNeeds).some(x => x === true) : true) &&
            (populationTypes ?
                Object.values(populationTypes).some(x => x === true) : true));
    }

    if(emailErrors.parent1EmailAddress) {
        isDisabled=emailErrors.parent1EmailAddress;
    }

    if(emailErrors.contact1EmailAddress) {
        isDisabled=emailErrors.contact1EmailAddress;
    }

    if(emailErrors.contact2EmailAddress) {
        isDisabled=emailErrors.contact2EmailAddress;
    }

    dispatch(setEnabledSubmit(isDisabled));
};

const formatPhoneNumbers = (tripModel) => {
    const tripRequestForm = tripModel;

    if (!validationPhoneNumber(tripModel.parent1MobilePhone)) {
        tripRequestForm.parent1MobilePhone = '';
    }
    if (!validationPhoneNumber(tripModel.parent1AltPhone)) {
        tripRequestForm.parent1AltPhone = '';
    }
    if (!validationPhoneNumber(tripModel.contact1MobilePhone)) {
        tripRequestForm.contact1MobilePhone = '';
    }
    if (!validationPhoneNumber(tripModel.contact2MobilePhone)) {
        tripRequestForm.contact2MobilePhone = '';
    }
    if (!validationPhoneNumber(tripModel.schoolPhone)) {
        tripRequestForm.schoolPhone = '';
    }
};

const convertToLocalDate = (ndate) => {
    if (!ndate) {
        return (ndate);
    }

    return (
        new Date(ndate.getUTCFullYear(),
            ndate.getUTCMonth(),
            ndate.getUTCDate(),
            ndate.getUTCHours(),
            ndate.getUTCMinutes(),
            ndate.getUTCSeconds())
    );
};

const formatDays = (tripModel) => {
    const tripRequestForm = tripModel;

    tripRequestForm.studentDateOfBirth = dateFormatDateOfBirth(tripModel.studentDateOfBirth);
    tripRequestForm.schoolArrivalMonday = timeFormat(convertToLocalDate(tripModel.schoolArrivalMonday));
    tripRequestForm.schoolArrivalTuesday = timeFormat(convertToLocalDate(tripModel.schoolArrivalTuesday));
    tripRequestForm.schoolArrivalWednesday = timeFormat(convertToLocalDate(tripModel.schoolArrivalWednesday));
    tripRequestForm.schoolArrivalThursday = timeFormat(convertToLocalDate(tripModel.schoolArrivalThursday));
    tripRequestForm.schoolArrivalFriday = timeFormat(convertToLocalDate(tripModel.schoolArrivalFriday));
    tripRequestForm.schoolArrivalSaturday = timeFormat(convertToLocalDate(tripModel.schoolArrivalSaturday));
    tripRequestForm.schoolArrivalSunday = timeFormat(convertToLocalDate(tripModel.schoolArrivalSunday));
    tripRequestForm.schoolPickupMonday = timeFormat(convertToLocalDate(tripModel.schoolPickupMonday));
    tripRequestForm.schoolPickupTuesday = timeFormat(convertToLocalDate(tripModel.schoolPickupTuesday));
    tripRequestForm.schoolPickupWednesday = timeFormat(convertToLocalDate(tripModel.schoolPickupWednesday));
    tripRequestForm.schoolPickupThursday = timeFormat(convertToLocalDate(tripModel.schoolPickupThursday));
    tripRequestForm.schoolPickupFriday = timeFormat(convertToLocalDate(tripModel.schoolPickupFriday));
    tripRequestForm.schoolPickupSaturday = timeFormat(convertToLocalDate(tripModel.schoolPickupSaturday));
    tripRequestForm.schoolPickupSunday = timeFormat(convertToLocalDate(tripModel.schoolPickupSunday));
    tripRequestForm.tripStartDate = !tripModel.tripStartDate ? '' : tripModel.tripStartDate;
    tripRequestForm.tripEndDate = !tripModel.tripEndDate ? '' : tripModel.tripEndDate;
};

export const onAccountEmailValidation = () => (dispatch, getState) => {
    const { tripModel } = getState().TripRequestFormReducers;

    if (tripModel.accountId) {
        const selectedAccount = Auth.getAccounts().find(x => x.AccountGUID === tripModel.accountId);

        if (!selectedAccount.Email) {
            dispatch(setSelectedAccountHasNoEmail(true));
            dispatch(setErrorMessage([]));

            return false;
        }
    }

    dispatch(setSelectedAccountHasNoEmail(false));

    return true;
};

export const resetValues = () => dispatch => {
    dispatch(isNewCorrect());
    dispatch(setErrorMessage([]));
    dispatch(setIsSameAddressCheck(false));
    dispatch(setIsSameContactCheck(false));
    dispatch(setIsSameSchoolCheck(false));
    dispatch(setIsSameTripInfoCheck(false));
    dispatch(setKeyDropZone(Math.random().toString()));
    dispatch(closeStyledSnackBar());
    dispatch(setPopulationTypes(populationTypeDto));
    dispatch(setSchedule(scheduleModel));
    dispatch(setSchoolDays(schoolDaysDto));
    dispatch(setSelectedHomeAddress({}));
    dispatch(setSelectedHomeAddress2({}));
    dispatch(setSelectedDropOffAddress({}));
    dispatch(setSelectedDropOffAddress2({}));
    dispatch(setSelectedPickUpAddress({}));
    dispatch(setSelectedPickUpAddress2({}));
    dispatch(setSelectedSchool({}));
    dispatch(setSelectedSchoolAddress({}));
    dispatch(setSelectedSchoolAddress2({}));
    dispatch(setShowDifferentAddress({
        pk: false,
        do: false
    }));
    dispatch(setUploadedDraftAttachments([]));
    dispatch(setTransportationNeeds(transportationEquipmentDto));
    dispatch(setEmailErrors({
        parent1EmailAddress: false,
        contact1EmailAddress: false,
        contact2EmailAddress: false
    }));
    dispatch(setEnabledSchoolInput({
        addressCity: false,
        addressZipCode: false,
        addressState: false,
        schoolPhone: false,
        schoolName: false
    }));
    dispatch(setIsDraftSelected(false));
    dispatch(setStudentStartDateErrorMessage(''));
    dispatch(setStudentEndDateErrorMessage(''));
    dispatch(setStudentBirthDateErrorMessage(''));
    dispatch(setNonSchoolAddressList([]));
    dispatch(setSelectedPreviousHomeAddress(""));
    dispatch(setSelectedPreviousDropOffAddress(""));
    dispatch(setSelectedPreviousPickUpAddress(""));
};

export const onAddForm = () => dispatch => {
    const model = {
        ...personalInformationModel,
        ...generalTripInformationModel,
        ...schoolInformationModel,
        ...emergencyContactInformationModel
    };

    initialValues(model);
    dispatch(updateModel(model));
    dispatch(setEnabledStudentDate(false));
    dispatch(setDefaultStudentId(''));
    dispatch(setSearchTerm(''));
    dispatch(resetValues());
    dispatch(setSelectedStudent({}));
    dispatch(setSelectedHomeAddress({}));
    dispatch(setSelectedHomeAddress2({}));
    dispatch(updateOldDraftModel({}));
    dispatch(setOldDraftPopulationTypes(populationTypeDto));
    dispatch(setOldDraftTransportationNeeds(transportationEquipmentDto));
    dispatch(setSelectedAccountHasNoEmail(false));
    dispatch(setErrorMessage([]));
};

export const onOpenSubmitModal = tabNumber => dispatch => {
    const submitMessage = localize('tripRequestForm.SubmitFormConfirm').replace(
        '#Number',
        tabNumber
    );

    dispatch(setSubmitConfirmModalStatus(true));
    dispatch(setSubmitFormMessage(submitMessage));
};

const submitTripRequestForm = (requestDto) => (dispatch, getState) => {
    dispatch(tripRequestFormResponseFile({ status: '' }));

    const body = JSON.stringify(requestDto);
    const hasTripTrackAccess = Auth.hasTripTrackingAccess();

    mrmFetch(`/api/v2/Request`,
        'post',
        null,
        body
    ).then((resp) => {
        dispatch(setTripRequestFormLoading(false));
        if (Array.isArray(resp)) {
            const { currentSibling, siblingNumber } = getState().TripRequestFormReducers;

            dispatch(onAddForm());

            dispatch(setSnackbar(
                localize('tripRequestForm.messageSuccess'),
                Enum.severityType.success
            ));

            if (siblingNumber === 1) {
                if (hasTripTrackAccess) {
                    dispatch(searchStudent('', true));
                    dispatch(onAddForm());
                }
            } else {
                dispatch(onDeleteTab(currentSibling));
            }
        } else {
            dispatch(setSnackbar(
                localize(errorLabel),
                Enum.severityType.error
            ));
        }
        dispatch(openStyledSnackBar());
        setTimeout(
            () => {
                dispatch(closeStyledSnackBar());
            },
            2000
        );
    }).catch(e => {
        dispatch(setTripRequestFormLoading(false));

        dispatch(setSnackbar(
            localize(errorLabel),
            Enum.severityType.error
        ));

        dispatch(openStyledSnackBar());
        window.warn(`error in submitTripRequestForm`,
            e
        );
    });
};

export const onLoadDefaultStudent = (locationState) => (dispatch) => {
    dispatch(setSearchTerm(locationState.studentCode));
    dispatch(setDefaultStudentId(locationState.studentId));
};

export const startTRF = () => async (dispatch, getState) => {
    const { calledGetCorrelationId, tripModel } = getState().TripRequestFormReducers;
    
    if (!calledGetCorrelationId && !tripModel.correlationId) {
        dispatch(setCalledGetCorrelationId(true));
        window.log("calling API to get CorrelationId");
        const response = await getCorrelationId();

        if (response?.correlationId) {
            dispatch(updateModel({correlationId: response.correlationId}));
            window.log("CorrelationId set to", response.correlationId);
        } else {
            window.log("Error getting CorrelationId");
            dispatch(setCalledGetCorrelationId(false));
        }
    }
};

export const onUpdateModel = (evt) => async (dispatch) => {
    const { name, type } = evt.target;
    const accounts = Auth.getAccounts();
    let { value } = evt.target;

    if (type === 'checkbox') {
        value = evt.target.checked;
    }

    if (name === 'studentId') {
        dispatch(setIsDraftSelected(false));
    }

    if (name === 'accountNumber') {
        const account = accounts.find(r => r.AccountID === value);

        dispatch(updateModel({
            accountId: account.AccountGUID,
            accountNumber: value,
            accountName: account.Name
        }));
    } else {
        dispatch(updateModel({
            [name]: name === 'studentId' ? value.trim() : value
        }));

        switch (name) {
        case 'parent1EmailAddress':
            dispatch(parentAppAccess(value, 'parent1AppAccess'));
            break;
        case 'contact1EmailAddress':
            dispatch(parentAppAccess(value, 'contact1AppAccess'));
            break;
        case 'contact2EmailAddress':
            dispatch(parentAppAccess(value, 'contact2AppAccess'));
            break;
        default:
            break;
        }
    }

    dispatch(isNewCorrect());
};

export const onSubmitTripForm = () => async (dispatch, getState) => {
    dispatch(formatPopulationTypeGeneralTripInfo());
    dispatch(formatTransporationNeeds());

    const { tripModel, emailErrors, isDraftSelected } = getState().TripRequestFormReducers;
    const validForm = isValidForm(tripModel, emailErrors);

    if (validForm.response) {
        tripModel.isDraftSelected = isDraftSelected;
        formatPhoneNumbers(tripModel);
        formatDays(tripModel);
        dispatch(submitTripRequestForm(tripModel));
    } else {
        dispatch(setErrorMessage(validForm.messages));
    }

    dispatch(setSubmitConfirmModalStatus(false));
};

export const onLoadForm = () => dispatch => {
    dispatch(cleanForm());
    dispatch(onAddForm());
    dispatch(searchStudent('', true));
};
